// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-comfy -> weidner-apartment-homes-theme-comfy -> admirals-cove
// Generated: 2026-11-02T18:12:24.160Z
// Counts: 0 design, 37 content, 23 slot group, 1 collection binding, 7 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Office Hours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.office_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Leasing Office</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.talk_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Let's Talk</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Gallery</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome To <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience Life Near Nunaka Valley Park</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Northeast Anchorage Living</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1><h1></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Admirals Cove in Anchorage, AK, every detail is designed for easy days. Enjoy in-home comforts like a washer and dryer, energy-efficient appliances, fireplaces, granite counters, and roomy closets. Step out to community conveniences, from the fitness center with cardio machines and a business center to a welcoming dog park and complimentary coffee station. Convenience and comfort greet you at every turn at Admirals Cove.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Have a question or want to learn more about making Admirals Cove your new home? Contact our Anchorage leasing team for availability or to schedule a tour.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover apartments for rent in Anchorage, AK, with easy-flow spaces just right for relaxing, entertaining, or setting up your work-from-home space. Each layout is designed for everyday comfort; enjoy features like granite countertops, cozy fireplaces, in-home laundry, and plenty of storage to keep everything organized and uncluttered. Create your ideal retreat, whether winding down after a busy day or inviting friends over for game night.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Picture yourself at Admirals Cove, where every apartment glows with natural Anchorage light. View our gallery of inviting kitchens, bright living rooms, and spacious layouts. Enjoy comfy fireplaces, spaces built for gathering, and community amenities like the fitness center and coffee bar. Get inspired for your next chapter; find the look and feel that best fits your lifestyle.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Settling in at Admirals Cove means being surrounded by everything Anchorage has to offer. Find yourself a stroll from Nunaka Valley Park or a round of golf at Russian Jack Springs. Daily life includes shopping at Eastgate Shopping Center and Walmart, trying local favorites like Muldoon Pizza, and exploring trails and winter sports. With easy access to Glenn Highway and public transportation, campus visits to Alaska Pacific University or the University of Alaska Anchorage are a breeze. Embrace the Anchorage lifestyle where parks, classes, and new flavors are all within reach.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Admirals Cove puts you just minutes from Nunaka Valley Park North, Russian Jack Springs Golf Course, and restaurants like Muldoon Pizza and Sunday’s Caribbean Cuisine. With Alaska Pacific University and the University of Alaska Anchorage nearby, plus easy access to Glenn Highway and public transportation, work, study, and fun are all a quick hop away.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Step into relaxed, comfortable living at Admirals Cove Apartment Homes. Our apartments for rent in Anchorage, AK, blend striking style with daily convenience. Picture nights by your own fireplace, a stroll to Nunaka Valley Park North, or quick trips to Walmart. Choose from comfort-focused floor plans and enjoy perks like a business center, fitness center, and on-site dog park. At Admirals Cove, you get more time for what matters most - lounging, gathering, and exploring Anchorage.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Dive into the Admirals Cove experience in Anchorage, AK - schedule a guided in-person or live virtual tour. Want to check out the fitness center, fireplace, and granite countertops firsthand? Use our simple scheduler to book a time that works for you. Both virtual and in-person tours are led by knowledgeable leasing professionals ready to guide you at your pace. Touring restrictions may apply.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Step into Admirals Cove from wherever you are and get a true sense of our Anchorage, AK apartments. Wander through layouts, picture daily routines, and soak in every detail at your own pace. Whether you want to explore different floor plans or get an up-close look at community areas, our virtual tours let you see it all from your sofa. Ready to go deeper? Use our tour scheduler to chat with our leasing team.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "customValue": "/apply-now",
        "mappedField": "property_apply_now_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "hero.feature_slide_3": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "footer.get_in_touch_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "amenities-hero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contact-hero.bg_image": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "gallery-hero.bg_image": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[14].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[14].image_media.alt_text"
      }
    }
  },
  "hero.feature_slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021a-4095-70e7-99a4-d05ba1a7133b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Gym with treadmills, ellipticals, and exercise bikes."
      }
    }
  },
  "hero.feature_slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021a-28a8-77ef-a6c2-520bf639a9b5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with fireplace, television, sofa, and armchair."
      }
    }
  },
  "hero.feature_slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021a-2992-7248-bf09-08977c672aaf.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious living room and kitchen area with a fireplace and TV."
      }
    }
  },
  "hero.feature_slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021a-35c4-742a-a038-bb4267d62017.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with a fireplace and a seating area"
      }
    }
  },
  "neighborhood-hero.bg_image": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "pet-policy-hero.bg_image": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "propertyoverview.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021a-348d-774e-8f23-dd4043cd4a62.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with fireplace and dining table"
      }
    }
  },
  "propertyoverview.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021a-349d-75bd-92e1-69686643cad8.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Dining area with two bar stools and a glass table, overlooking a balcony with greenery."
      }
    }
  },
  "propertyoverview.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021a-438d-70c5-8a80-d39cc42b902a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of apartment building with balconies and green trees."
      }
    }
  },
  "residentaccess.payrent_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021a-1d04-71fe-935b-10b35e2cc171.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with light wood cabinets, granite countertops, white appliances, and a breakfast bar with stools."
      }
    }
  },
  "residentaccess.portal_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021a-29e8-734b-bbca-cb084d8524c7.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with a queen-size bed, nightstand, dresser, and window."
      }
    }
  },
  "residentaccess.service_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021a-28a8-77ef-a6c2-520bf639a9b5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with fireplace, television, sofa, and armchair."
      }
    }
  },
  "schedule-tour-hero.bg_image": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "photogallery.images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "ec_7ee52e50e749593d3bcaca6e",
      "ec_4b4bd2bbffe7007a686a1ebd",
      "ec_0fa6a523b1deb320986cf24a",
      "ec_02f1da8de925d217f3cb6609",
      "ec_f8574bd358d68b5ba3c82446",
      "ec_a2237029f514cc492c84c6b9",
      "ec_40d9234a0a2aaf67cd32b49e",
      "ec_6fb88f1526a0ef9899c54a94",
      "ec_eef6952e0771d712803edbeb",
      "ec_43e1404ac0c2d959575372f8",
      "ec_afab340cacdb06e8518984b6",
      "ec_48b86caa4b271537c481bf2d",
      "ec_134fac65bb31311d93e55cf1",
      "ec_0d5cc181105732311edfffaf",
      "ec_04abe16f2371661957042255",
      "ec_f64ffdc76ba7b4d58f0f985f"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
